/**
 * byValue
 * Returns copy of the item without reference to orginal
 * @param item
 */
export const byValue = <T>(item: T): T => {
  return JSON.parse(JSON.stringify(item))
}

/**
 * extend
 * Extends object with another object. Adding object keys - not deleting.
 * Overwriting string, number, array and boolean values.
 * (similar way than JQuery's $.extend does with deepcopy option set to true)
 * @param baseObject
 * @param extendingObject
 * @param returnAsNewObject Defaults false. If set to true, returns new object rather than reference to the original one
 */

type supportedObjectType = {
  [key: string]:
    | supportedObjectType
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    | any[]
    | string
    | boolean
    | number
    | null
    | undefined
}

export const extend = <ReturnType>(
  baseObject: Record<string, unknown>,
  extendingObject: supportedObjectType,
  ByValue = false
): ReturnType => {
  let obj: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any
  }

  if (!ByValue) {
    obj = baseObject
  } else {
    obj = byValue(baseObject)
  }

  const keys = Object.keys(extendingObject)

  for (let i = 0; i < keys.length; i += 1) {
    const val = extendingObject[keys[i]]

    obj[keys[i]] =
      typeof val === 'string' ||
      typeof val === 'number' ||
      typeof val === 'boolean' ||
      typeof val === 'undefined' ||
      Array.isArray(val) ||
      val === null
        ? val
        : extend(obj[keys[i]] || {}, val)
  }

  return obj as ReturnType
}
